import React from "react";
import { formatTimelineTime } from "@racoon/ui";
import { cn } from "@racoon/ui";

interface PlaybackInfoProps {
  currentTime: number | null;
  lat?: number;
  lon?: number;
  speed?: number;
  angle?: number;
  className?: string;
}

export function PlaybackInfo({ currentTime, lat, lon, speed, className }: PlaybackInfoProps) {
  if (currentTime === null) return null;

  return (
    <div
      className={cn(
        "grid grid-cols-4 gap-2 text-xs bg-white border rounded-lg p-3 w-[25rem]",
        className,
      )}
    >
      <div className="flex flex-col gap-1">
        <div className="text-muted-foreground font-medium">Время</div>
        <div className="font-mono font-semibold text-sm">{formatTimelineTime(currentTime)}</div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-muted-foreground font-medium">Скорость</div>
        <div className="font-mono font-semibold text-sm ">
          {speed !== undefined ? `${speed.toFixed(1)} км/ч` : "—"}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-muted-foreground font-medium">Широта</div>
        <div className="font-mono font-semibold text-sm ">
          {lat !== undefined ? lat.toFixed(6) : "—"}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-muted-foreground font-medium">Долгота</div>
        <div className="font-mono font-semibold text-sm ">
          {lon !== undefined ? lon.toFixed(6) : "—"}
        </div>
      </div>
    </div>
  );
}
